<div [ngClass]="childPopUpShown ? 'fade-parent' : ''">
  <div id="loading-timeslot-booking">
    <div class="modal-header">
      <div class="headerDetailsContainer">
        <h2 id="set-loading-timeslot-title">
          <div *ngIf="isLoading">
            <span class="title-text">
              <span>
                {{
                  'SHARED.SECTION-TITLE-BOOK-LOADING-TIMESLOT' | translate
                }}: </span
              ><span>
                {{ 'ORDER-TABLE.HEADER-ORDER' | translate }} -
                {{ this.order.orderId }}
              </span>
            </span>
          </div>
          <div *ngIf="isDelivery">
            <span class="title-text">
              <span>
                {{
                  'SHARED.SECTION-TITLE-BOOK-DELIVERY-TIMESLOT' | translate
                }}: </span
              ><span>
                {{ 'ORDER-TABLE.HEADER-ORDER' | translate }} -
                {{ this.order.orderId }}
              </span>
            </span>
          </div>
        </h2>
      </div>
    </div>

    <div class="modal-body">
      <div class="container container-lg">
        <div class="row button-container justify-content-around">
          <div
            class="loadingTimeSlot timeslot-indicator"
            *ngIf="!this.loadedAreas"
          ></div>
          <div class="loadingTimeSlot" *ngIf="this.loadedAreas">
            <p
              class="timeslot-confimed-text"
              *ngIf="!timeslotBookingIsAvailable"
            >
              {{ 'TIMESLOT.TIMESLOT-CONFIRMED' | translate }}
            </p>
            <p
              class="order-needs-confirmation-text"
              *ngIf="orderStatusIsAnnouncedToCarrier"
            >
              {{ 'TIMESLOT.ORDER-NEEDS-CONFIRMATION-WARNING' | translate }}
            </p>

            <p
              *ngIf="
                (!datesAvailableForBooking || !timeslotsAvailableForBooking) &&
                !validPeriodHasPassed
              "
            >
              {{ 'TIMESLOT.TIMESLOT-NOT-AVAILABLE' | translate }}
            </p>
            <p
              *ngIf="
                datesAvailableForBooking && validPeriodHasPassed;
                else empty
              "
            >
              {{ 'TIMESLOT.BOOKING-PERIOD-EXPIRED' | translate }}
            </p>
            <ng-template #empty><div class="empty-space"></div></ng-template>

            <div id="area-and-date">
              <!-- Area field -->
              <div class="col-12">
                <div
                  class="row area-date-timeslot-select align-items-center"
                  id="area-select"
                >
                  <div class="col-xl-2 col-sm-2">
                    <h2 class="label mobile-font-size-details-on-blue">
                      {{
                        'ORDER-LIST-DETAILS.TS-AREA-TABLE-TITLE-COMP-AREA'
                          | translate
                      }}:
                    </h2>
                  </div>
                  <div class="col-12 col-xl-10 col-sm-10">
                    <mat-form-field
                      class="areaDateSelect mobile-font-size-details-on-blue"
                      id="area-dropdown"
                      floatLabel="never"
                    >
                      <mat-select
                        #areaSelect
                        [(ngModel)]="selectedAreaId"
                        (ngModelChange)="onAreaChange()"
                        [disabled]="!timeslotBookingIsAvailable"
                        [placeholder]="
                          'ORDER-LIST-DETAILS.TS-AREA-PLACEHOLDER' | translate
                        "
                      >
                        <mat-option
                          *ngFor="let area of areas"
                          [value]="area.areaId"
                        >
                          {{ area.code }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <!-- Date field -->
              <div class="col-12">
                <div
                  class="row area-date-timeslot-select align-items-center"
                  id="date-select"
                >
                  <div class="col-xl-2 col-sm-2">
                    <h2 class="label mobile-font-size-details-on-blue">
                      {{
                        'ORDER-LIST-DETAILS.TS-AREA-TABLE-TITLE-COMP-DATE'
                          | translate
                      }}:
                    </h2>
                  </div>
                  <div class="col-12 col-xl-10 col-sm-10">
                    <mat-form-field
                      class="areaDateSelect mobile-font-size-details-on-blue"
                      id="date-dropdown"
                      floatLabel="never"
                    >
                      <mat-select
                        [(ngModel)]="selectedDate"
                        (ngModelChange)="
                          setDirtyDateFalse(); onTimeslotDateChange()
                        "
                        [placeholder]="
                          'ORDER-LIST-DETAILS.TS-DATE-PLACEHOLDER' | translate
                        "
                        [disabled]="
                          !timeslotBookingIsAvailable ||
                          !datesAvailableForBooking ||
                          !selectedAreaId
                        "
                      >
                        <mat-option
                          *ngFor="
                            let date of isLoading
                              ? order.loadingDates
                              : order.deliveryDates
                          "
                          [value]="date"
                        >
                          {{ CommonUtils.formatDate(date) }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <!-- Timeslot field -->
              <div class="col-12">
                <div
                  class="row area-date-timeslot-select align-items-center"
                  id="timeslot-select"
                >
                  <div class="col-xl-2 col-sm-2">
                    <h2 class="label mobile-font-size-details-on-blue">
                      {{
                        'ORDER-LIST-DETAILS.TS-AREA-TABLE-TITLE-COMP-TIMESLOT'
                          | translate
                      }}:
                    </h2>
                  </div>
                  <div class="col-12 col-xl-10 col-sm-10">
                    <mat-form-field
                      class="areaDateSelect mobile-font-size-details-on-blue"
                      id="timeslot-dropdown"
                      floatLabel="never"
                      [class.mat-form-field-invalid]="hasError"
                    >
                      <mat-select
                        #timeslot="ngModel"
                        required
                        [(ngModel)]="this.selectedTimeslotId"
                        [placeholder]="
                          'ORDER-LIST-DETAILS.TS-TIMESLOT-PLACEHOLDER'
                            | translate
                        "
                        [disabled]="
                          !timeslotBookingIsAvailable ||
                          !datesAvailableForBooking ||
                          !timeslotsAvailableForBooking ||
                          validPeriodHasPassed ||
                          !selectedDate
                        "
                      >
                        <mat-option
                          *ngFor="let timeslot of availableTimeslots"
                          [value]="timeslot.id"
                        >
                          <span
                            *ngIf="
                              areaHasMultipleDocksAvailable;
                              else singleDock
                            "
                          >
                            {{ CommonUtils.formatTime(timeslot.start) }} (Dock
                            {{ timeslot.dockNumber }})
                          </span>
                          <ng-template #singleDock>
                            {{ CommonUtils.formatTime(timeslot.start) }}
                          </ng-template>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row control-btns justify-content-end buttons-row">
          <button
            mat-raised-button
            color="primary"
            type="button"
            [disabled]="
              this.timeslotDisabled ||
              this.selectedTimeslotId == undefined ||
              isImpersonated
            "
            class="control-btn"
            (click)="setTimeslot()"
          >
            <span
              class="mobile-font-size-details-on-blue desktop-font-size mobile-elem bluebox"
            >
              {{ 'SHARED.BOOK' | translate }}
            </span>
          </button>
          <button
            mat-flat-button
            class="control-btn"
            aria-label="Close"
            (click)="activeModal.dismiss('close')"
          >
            <span
              class="mobile-font-size-details-on-blue desktop-font-size mobile-elem bluebox"
            >
              {{ 'SHARED.MODAL-CLOSE' | translate }}
            </span>
          </button>
        </div>
        <ngx-spinner
          bdColor="rgba(51,51,51,0.4)"
          size="large"
          color="white"
          type="ball-scale-multiple"
          [fullScreen]="false"
        >
          <b class="primary-color">{{ 'TIMESLOT.LOADING' | translate }}</b>
        </ngx-spinner>
      </div>
    </div>
  </div>
</div>
